exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css"), undefined);

// module
exports.push([module.id, "._2T7X-gVlHcw7wF6MdtQPPq {\n  font-size: 12px;\n  color: " + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["silver"] + ";\n  width: 70%;\n  margin: 0 auto;\n  line-height: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"silver": "" + require("-!../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../styles/variables/colors.css").locals["silver"] + "",
	"copyrightStatement": "_2T7X-gVlHcw7wF6MdtQPPq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/CopyrightStatement/CopyrightStatement.css
// module id = 9594
// module chunks = 23